import React from "react";
import get from "lodash/get";
import { config } from "../utils";

const isLoading = (status, responseStatus, postStatus) => {
  return (
    (status === config.STATUS.IP) ||
    (responseStatus === config.STATUS.IP) ||
    (postStatus === config.STATUS.IP)
  );
}
const isFailure = (status) => status === config.STATUS.F;

const ComponentRenderer = ({
  children,
  status,
  response,
  postApiState,
}) => {
  const responseStatus = get(response, "status", "");
  const postStatus = get(postApiState, "postStatus", "");
  const message = get(response, "message", "Something went wrong!");
  const postResponseMessage = get(
    postApiState,
    "response.message",
    "Your feedback has been submitted successfully."
  );

  if (isLoading(status, responseStatus, postStatus)) {
    return (
      <div className="needHelp__Content">
        <div className="railLoader" />
      </div>
    )
  };

  if (isFailure(status)) {
    return (
      <div className="needHelp__Content">
        <div>{ message }</div>
      </div>
    )
  }

  if (postStatus === config.STATUS.D) {
    return <div className="needHelp__Content font16 lineHeight22">{postResponseMessage}</div> 
  }

  return children;
}

export default ComponentRenderer;
